import { createTheme, ThemeOptions } from '@material-ui/core/styles';
const media = createTheme({})

const theme: ThemeOptions = {
  //thats done for using breakpoints
  ...media,
  typography: {
    fontFamily: 'CircularRegular'
  },
  palette: {
    primary: {
      main: '#4f9b44',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#F41211',
      contrastText: '#ffffff'
    },
    warning: {
      main: '#F41211',
      contrastText: '#ffffff'
    },
    grey: {
      100: '#E5E5E5', // for lines
      200: '#F1F2F4', // for background
      300: '#80868E' // for text
    },
  },
  overrides: {
    MuiIconButton: {
      root: {
        color: 'rgba(0, 0, 0, 0.87)',
        fontWeight: 400
      }
    },
    MuiTypography: {
      h5: {
        fontFamily: 'CircularBold'
      },
      h4: {
        fontFamily: 'CircularBold'
      },
      h3: {
        fontFamily: 'CircularBold'
      },
      h2: {
        fontFamily: 'CircularBold'
      },
      h1: {
        fontFamily: 'CircularBold'
      }
    },
    MuiListItemIcon: {
      root: {
        color: 'rgba(0, 0, 0, 0.87)',
        fontWeight: 400
      }
    },
    MuiTabs: {
      indicator: {
        display: 'none'
      },
      root: {
        minHeight: '40px',
        fontWeight: 400
      }
    },
    MuiTab: {
      root: {
        minHeight: '40px',
        fontWeight: 400,
        [media.breakpoints.up('sm')]: {
          minWidth: 'auto'
        }
      },
      textColorInherit: {
        opacity: '1'
      }
    },
    MuiChip: {
      colorPrimary: {
        backgroundColor: '#49CC5B'
      }
    },
    MuiInputLabel: {
      outlined: {
        fontSize: '0.8rem',
        transform: 'translate(8px, 10px) scale(1)'
      }
    },
    MuiTableCell: {
      head: {
        fontWeight: 400
      }
    },
    MuiDialogActions: {
      root: {
        padding: '16px 0 0'
      }
    },
    MuiButton: {
      containedPrimary: {
        backgroundColor: '#4f9b44',
        '&:hover': {
          backgroundColor: '#3f7c36'
        }
      }
    }
    // MuiButtonBase: {
    //   root: {
    //     fontFamily: 'CircularRegular'
    //   }
    // },
    // MuiGrid: {
    //   root: {
    //     fontFamily: 'CircularRegular'
    //   }
    // }
  }
}

export { theme }
